import styled, {css} from "styled-components";

export const TitleBox = styled.div<{isOpen: boolean}>`
    position: relative;
    font-size: 15px;
    ${({theme}) => theme.font.presets.bold};
    color: ${props => props.theme.colors.textLight};
    text-transform: uppercase;
    display: flex;
    align-items: center;

    /* Title V sign */
    &:after {
          content: " ";
          display: inline-block;

          border: solid ${props => props.theme.colors.backgroundContrast};
          border-width: 0 2px 2px 0;

          padding: 3px;
          transform: rotate(45deg);

          position: absolute;
          right: 0;

          ${props => props.isOpen && css`
            transform: rotate(225deg);
          `}
    }
`;